module.exports = __webpack_public_path__ + "static/img/22.f24d2f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/22.png
// module id = a2qL
// module chunks = 0